var _excluded = ["size", "className", "millisecondOfDebounce"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import { Button as AntdButton } from 'antd';
import { debounce } from 'lodash-es';
import useStyles from "./style";
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    className = _ref.className,
    _ref$millisecondOfDeb = _ref.millisecondOfDebounce,
    millisecondOfDebounce = _ref$millisecondOfDeb === void 0 ? 0 : _ref$millisecondOfDeb,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      size: size
    }),
    st = _useStyles.styles,
    cx = _useStyles.cx;
  var buttonClickHandler = debounce(function (e) {
    if (rest.onClick) {
      rest.onClick(e);
    }
  }, millisecondOfDebounce, {
    leading: false,
    trailing: true
  });
  return /*#__PURE__*/React.createElement(AntdButton, _extends({
    ref: ref
  }, rest, {
    onClick: buttonClickHandler,
    className: cx(st.buttonWrap, className)
  }), rest.children);
});
if (process.env.NODE_ENV !== 'production') {
  Button.displayName = 'Button';
}
export default Button;